import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { RefreshCw, X } from "lucide-react";
import { useState } from "react";

const PWAUpdateBanner = ({
    onReload,
    onDismiss,
}: {
    onReload: () => void;
    onDismiss: () => void;
}) => {
    const [isReloading, setIsReloading] = useState(false);

    const handleReload = () => {
        setIsReloading(true);
        try {
            onReload();
        } catch (error) {
            console.error("Error reloading app:", error);
            setIsReloading(false);
        }
    };

    return (
        <Card className="fixed top-4 right-4 z-50 p-4 shadow-lg border-blue-200 bg-blue-50">
            <div className="flex items-center gap-3">
                <RefreshCw 
                    className={`h-4 w-4 text-blue-600 ${
                        isReloading ? "animate-spin" : ""
                    }`} 
                />
                <span className="text-sm font-medium">
                    {isReloading ? "Updating..." : "Update available"}
                </span>
                <div className="flex gap-2">
                    <Button 
                        size="sm" 
                        onClick={handleReload}
                        disabled={isReloading}
                    >
                        Reload
                    </Button>
                    <Button 
                        size="sm" 
                        variant="ghost" 
                        onClick={onDismiss}
                        disabled={isReloading}
                    >
                        <X className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </Card>
    );
};

export default PWAUpdateBanner;
